import { makeStyles } from '@material-ui/core/styles'
import get from 'lodash/get'
import { linkToRecord } from 'react-admin'
import { Link } from 'react-router-dom'

const useStyles = makeStyles({
  link: {
    textDecoration: 'none',
  },
  linkText: {
    color: 'inherit',
  },
})

// useful to prevent click bubbling in a datagrid with rowClick
const stopPropagation = (e: any) => e.stopPropagation()

export const CustomReferenceField = ({
  record,
  source,
  baseUrl,
  representationFunction,
  appendUrl = '',
}: any) => {
  const classes = useStyles()
  if (!record || !source) return null
  const object = get(record, source)
  return object ? (
    <Link
      to={linkToRecord(baseUrl, object.id, 'show') + appendUrl}
      onClick={stopPropagation}
      className={classes.link}
    >
      <span className={classes.linkText}>{representationFunction(object)}</span>
    </Link>
  ) : null
}
